"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var i0 = require("@angular/core");
var i1 = require("@angular/router");
/**
 * Catch-all fallback guard: sends any unmatched URL to the registration start,
 * dropping every query param (programmatic navigate does not carry them over).
 */
var RedirectToRegistrationGuard = /** @class */ (function () {
    function RedirectToRegistrationGuard(router) {
        this.router = router;
    }
    RedirectToRegistrationGuard.prototype.canActivate = function () {
        this.router.navigate(['/registration']);
        return false;
    };
    RedirectToRegistrationGuard.ngInjectableDef = i0.defineInjectable({ factory: function RedirectToRegistrationGuard_Factory() { return new RedirectToRegistrationGuard(i0.inject(i1.Router)); }, token: RedirectToRegistrationGuard, providedIn: "root" });
    return RedirectToRegistrationGuard;
}());
exports.RedirectToRegistrationGuard = RedirectToRegistrationGuard;
